module.exports = __webpack_public_path__ + "mr.svg?55d8f233036c23373ecf6eade8d735a1";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/mr.svg
// module id = 1255
// module chunks = 0